import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { journalsQueries } from "@/entities/journal";

export const useModalInfo = (
  itemNoVersionId?: string,
  options?: Omit<UseQueryOptions<any, any, any, any>, "queryKey" | "queryFn">,
) => {
  return useQuery({
    ...journalsQueries.getSectionFourItem({
      itemNoVersionId: itemNoVersionId || "",
    }),
    ...options,
  });
};
